import React, { memo } from 'react'

import * as Styled from './styled'

interface IProps {
  loaderColor: string
  size?: number
  wrapperSize?: number
  className?: string
  strokeWidth?: number
}

const SpinningLoader: React.FC<IProps> = ({
  loaderColor,
  size = 18,
  wrapperSize = 30,
  className,
  strokeWidth = 3
}) => {
  return (
    <Styled.SpinningLoaderWrapper
      $wrapperSize={wrapperSize}
      className={className}
    >
      <Styled.SpinningLoaderSvg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 28 28"
        fill="none"
        $size={size}
      >
        <path
          d="M26 14C26 16.7763 25.0374 19.4666 23.2761 21.6127C21.5149 23.7588 19.064 25.2278 16.3411 25.7694C13.6182 26.311 10.7917 25.8918 8.34324 24.5831C5.89479 23.2743 3.97588 21.1571 2.91345 18.5922C1.85102 16.0273 1.71081 13.1733 2.51672 10.5166C3.32262 7.85987 5.02478 5.56477 7.33316 4.02237C9.64153 2.47996 12.4133 1.78566 15.1762 2.05778C17.9391 2.3299 20.5222 3.5516 22.4853 5.51472"
          stroke={loaderColor}
          strokeWidth={strokeWidth}
        />
      </Styled.SpinningLoaderSvg>
    </Styled.SpinningLoaderWrapper>
  )
}

export default memo(SpinningLoader)
